var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMah(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 36 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5645 33C26.4971 33 33.7385 26.0604 33.7385 17.5C33.7385 8.93959 26.4971 2 17.5645 2C8.63193 2 1.39062 8.93959 1.39062 17.5C1.39062 26.0604 8.63193 33 17.5645 33Z",
    stroke: "#838990",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.88281 13.625C9.88281 13.1111 10.0958 12.6183 10.475 12.255C10.8541 11.8916 11.3684 11.6875 11.9046 11.6875C12.4408 11.6875 12.955 11.8916 13.3341 12.255C13.7133 12.6183 13.9263 13.1111 13.9263 13.625",
    stroke: "#838990",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0137 13.625C22.0137 13.3706 22.066 13.1186 22.1676 12.8836C22.2692 12.6485 22.4181 12.4349 22.6058 12.255C22.7936 12.0751 23.0164 11.9324 23.2617 11.835C23.507 11.7376 23.7699 11.6875 24.0354 11.6875C24.3009 11.6875 24.5638 11.7376 24.8091 11.835C25.0544 11.9324 25.2773 12.0751 25.465 12.255C25.6527 12.4349 25.8017 12.6485 25.9033 12.8836C26.0049 13.1186 26.0572 13.3706 26.0572 13.625",
    stroke: "#838990",
    strokeWidth: 2.69565,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4062 25.1387C23.4062 25.1387 22.3216 22.9094 17.9914 21.6848C13.6613 20.4602 11.5705 21.7914 11.5705 21.7914",
    stroke: "#838990",
    strokeWidth: 2.7,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMah);
export default __webpack_public_path__ + "static/media/mah.ea668ddc373991e0f7d2adbeb7827dae.svg";
export { ForwardRef as ReactComponent };